import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { NAV_ITEMS, visibleGroups, useNavAccess } from '../lib/nav';

export { NAV_ITEMS };

function NavList({ onNavigate, compact = false }) {
  const access = useNavAccess();
  return (
    <div className="py-3">
      {visibleGroups(undefined, access).map((g) => (
        <div key={g.label || 'top'} className="mb-2">
          {(g.items.length > 1 || g.items[0].label !== g.label) && <div className="px-6 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-wider text-[var(--text-secondary)] opacity-70">{g.label}</div>}
          {g.items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              onClick={onNavigate}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 ${compact ? 'py-2' : 'py-2.5'} text-sm font-medium transition-colors ${
                  isActive
                    ? 'text-primary bg-primary/10 border-r-2 border-primary'
                    : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-gray-50 dark:hover:bg-slate-800'
                }`
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </div>
      ))}
    </div>
  );
}

export default function Sidebar() {
  return (
    <nav className="w-56 bg-white dark:bg-slate-900 border-r border-[var(--border)] shrink-0 hidden md:block overflow-y-auto">
      <NavList compact />
    </nav>
  );
}

// Phones: the sidebar is hidden below md; the header's menu button opens this drawer.
export function MobileNav({ open, onClose }) {
  const location = useLocation();
  useEffect(() => { if (open) onClose(); }, [location.pathname]); // close after navigating
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 md:hidden" role="dialog" aria-label="Menu">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <nav className="absolute inset-y-0 left-0 w-72 max-w-[85vw] overflow-y-auto bg-white shadow-xl dark:bg-slate-900">
        <div className="flex items-center justify-between border-b border-[var(--border)] px-4 py-3">
          <span className="font-semibold text-primary">Menu</span>
          <button onClick={onClose} className="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-slate-800" aria-label="Close menu"><X size={18} /></button>
        </div>
        <NavList onNavigate={onClose} />
      </nav>
    </div>
  );
}
